import { useEffect, useState } from 'react';
import { Switch } from '../ui/switch';
import { supabase } from '../../lib/supabase';
import { usePartnerStore } from '../../lib/stores/partnerStore';
import { usePermissions } from '../../lib/hooks/usePermissions';
import { useApp } from '../AppProvider';

/**
 * Consenso newsletter del partner (external_partners.newsletter_subscribed): le liste con
 * tipologia "Partner" prendono solo i partner con consenso; la disiscrizione lo spegne.
 *
 * Salva da solo invece di passare da updatePartner: quello mette lo store in loading e
 * la scheda si ricaricherebbe a ogni clic. Lo store viene poi aggiornato a mano, cosi'
 * tabella e scheda restano allineate.
 */
export function PartnerNewsletterSwitch({ partnerId, subscribed }: { partnerId: string; subscribed: boolean }) {
  const { canEditPartner } = usePermissions();
  const { toast } = useApp();
  const [value, setValue] = useState(subscribed);
  const [saving, setSaving] = useState(false);
  useEffect(() => { setValue(subscribed); }, [partnerId, subscribed]);

  const handleChange = async (checked: boolean) => {
    setValue(checked);
    setSaving(true);
    const { error } = await supabase
      .from('external_partners')
      .update({ newsletter_subscribed: checked })
      .eq('id', partnerId);
    setSaving(false);
    if (error) {
      setValue(!checked);
      toast.error('Errore durante il salvataggio della newsletter');
      return;
    }
    usePartnerStore.setState((state) => ({
      partners: state.partners.map((p) => (p.id === partnerId ? { ...p, newsletter_subscribed: checked } : p)),
      selectedPartner: state.selectedPartner?.id === partnerId
        ? { ...state.selectedPartner, newsletter_subscribed: checked }
        : state.selectedPartner,
    }));
  };

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-[#37352F] dark:text-white">{value ? 'Iscrizione attiva' : 'Non iscritto'}</span>
      <Switch checked={value} onCheckedChange={handleChange} disabled={!canEditPartner || saving} />
    </div>
  );
}
